.consolidation-dispatch-gantt {
  display: grid;
  gap: 4px;
}

.consolidation-dispatch-gantt-scroll {
  min-width: 0;
  overflow-x: auto;
  border-radius: 4px;
}

.consolidation-dispatch-gantt-scroll:focus-visible {
  outline: 2px solid var(--color-accent);
  outline-offset: 2px;
}

.consolidation-dispatch-gantt-visual {
  min-width: 1100px;
}

.consolidation-dispatch-gantt-content {
  display: grid;
  gap: 4px;
}

.consolidation-dispatch-gantt-content * {
  animation: none !important;
  transition: none !important;
  cursor: default !important;
}

.consolidation-dispatch-gantt-content [class*="rounded-"] {
  border-radius: 4px;
}

/* Keep the same horizontal row on mobile; only the local viewport scrolls. */
.consolidation-dispatch-gantt [data-fleet-timeline-row] > .grid {
  grid-template-columns: minmax(94px, 106px) minmax(0, 1fr);
  align-items: center;
}

.consolidation-dispatch-gantt-scale > .grid {
  grid-template-columns: minmax(94px, 106px) minmax(0, 1fr) 4.75rem;
  align-items: center;
}

.consolidation-dispatch-gantt-scale > .grid > [aria-hidden="true"] {
  display: block;
}
